<template>
  <transition
    enter-active-class="transition ease-in-out duration-200"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition ease-in-out duration-200"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div v-show="file.percentage && file.percentage !== 100">
      <!-- Upper -->
      <div class="text-xs">
        {{ file.file.name }}
      </div>

      <!-- Lower -->
      <div>
        <!--
        <span v-if="file.status === 'failed'">
          <b class="text-red-700">Failed</b>
        </span>
        <span v-if="file.status === 'success'">
          <b class="text-green-700">OK</b>
        </span>
        -->
        <div class="flex gap-4 items-center">
          <ProgressBar
            v-if="file.status === 'uploading'"
            :progress="file.percentage"
          />
          <span v-if="file.status === 'uploading'">
          <b> {{ file.percentage }}% </b>
        </span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ProgressBar from "./ProgressBar.vue";

export default {
  props: ['file'],
  components: {ProgressBar}
}

</script>
